import React from 'react';
import styled from 'styled-components';
import DropdownSelect from './DropdownSelect';
import FilterContainer from './FilterContainer';
import { getData , getImpactSectionQuestionList } from '../utils/api';
import PercentageChart from './PercentageChart';
import LocationChart from './LocationChart';
import CompanySizeChart from './CompanySizeChart';

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  height: calc(100vh - 150px);
  overflow-y: scroll;

  &::-webkit-scrollbar{
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
      background-color: white;
      -webkit-border-radius: 4px;
    }

  & ::selection{
    text-shadow: none !important;
    background: none !important;
    color: #ffffff;
  }
`

const Footer = styled.div`
  width: 100%;
  position: relative;
  height: 30px;
  margin-top: 10px;
  background: #122035;

  &>p{
    color: white;
    font-size: 12px;
    font-family: 'Roboto';
    margin-bottom: 0;
    position: relative;
    float: right;
    margin-top: 5px;
    margin-right: 5%;
  }
`
export default class ImpactSectionContainer extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      data: null,
      currentSelectedItem: 1,
      currentFilterOption: 'percentage'
    }
    this.changeSelectedItem = this.changeSelectedItem.bind(this);
    this.changeFilterOption = this.changeFilterOption.bind(this);
    this.generateChart = this.generateChart.bind(this);
  }

  changeFilterOption(option){
    if(this.state.currentFilterOption != option){
      this.setState({currentFilterOption: option});
    }
  }

  changeSelectedItem(id){
    if(this.state.currentSelectedItem != id){
      this.setState({currentSelectedItem: id});
    }
  }

  componentDidMount() {
    //fetching data
    this.setState({
      data: getData(),
      list: getImpactSectionQuestionList()
    })
  }

  generateChart(){
    if(this.state.currentFilterOption === 'percentage'){
      return (<PercentageChart
        data={this.state.data}
        list={this.state.list}
        currentSelectedItem = {this.state.currentSelectedItem}
      />)
    }
    else if (this.state.currentFilterOption === 'location') {
      return (<LocationChart
        data={this.state.data}
        list={this.state.list}
        currentSelectedItem = {this.state.currentSelectedItem}
      />)
    }
    else if (this.state.currentFilterOption === 'companySize') {
      return (<CompanySizeChart
        data={this.state.data}
        list={this.state.list}
        currentSelectedItem = {this.state.currentSelectedItem}
      />)
    }
  }

  render(){

    return(
      <div>
        <Wrapper>
          <DropdownSelect
            list={this.state.list}
            currentSelectedItem = {this.state.currentSelectedItem}
            changeSelectedItem = {this.changeSelectedItem}
          />
          <FilterContainer
            currentFilterOption = {this.state.currentFilterOption}
            changeFilterOption = {this.changeFilterOption}
          />
          {this.generateChart()}
        </Wrapper>

        <Footer>
          <p>2018 United Nations Global Compact Progress Report</p>
        </Footer>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/ImpactSectionContainer.js